import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/settings/voidOrDiscountReasons.ts
var VoidOrDiscountReasonEnum = /* @__PURE__ */ ((VoidOrDiscountReasonEnum2) => {
  VoidOrDiscountReasonEnum2["VOID_ONLY"] = "voidOnly";
  VoidOrDiscountReasonEnum2["DISCOUNT_ONLY"] = "discountOnly";
  VoidOrDiscountReasonEnum2["BOTH"] = "both";
  return VoidOrDiscountReasonEnum2;
})(VoidOrDiscountReasonEnum || {});
var getVoidOrDiscountReasonObject = (newValue) => {
  switch (newValue) {
    case "voidOnly" /* VOID_ONLY */:
      return {
        isVoid: true,
        isDiscount: false
      };
    case "discountOnly" /* DISCOUNT_ONLY */:
      return {
        isVoid: false,
        isDiscount: true
      };
    case "both" /* BOTH */:
      return {
        isVoid: true,
        isDiscount: true
      };
  }
};
var getVoidOrDiscountReasonEnumValue = ({
  isVoid,
  isDiscount
}) => {
  if (isVoid && !isDiscount) {
    return "voidOnly" /* VOID_ONLY */;
  }
  if (!isVoid && isDiscount) {
    return "discountOnly" /* DISCOUNT_ONLY */;
  }
  return "both" /* BOTH */;
};
var getVoidOrDiscountReasonString = ({
  isVoid,
  isDiscount
}) => {
  switch (getVoidOrDiscountReasonEnumValue({ isVoid, isDiscount })) {
    case "voidOnly" /* VOID_ONLY */:
      return i18n_config_default.t(
        "settingsModule.registerModeSettings.general.discountReasons.voidOrDiscountReasons.options.voidOnly"
      );
    case "discountOnly" /* DISCOUNT_ONLY */:
      return i18n_config_default.t(
        "settingsModule.registerModeSettings.general.discountReasons.voidOrDiscountReasons.options.discountOnly"
      );
    case "both" /* BOTH */:
      return i18n_config_default.t(
        "settingsModule.registerModeSettings.general.discountReasons.voidOrDiscountReasons.options.both"
      );
  }
};

export { VoidOrDiscountReasonEnum, getVoidOrDiscountReasonEnumValue, getVoidOrDiscountReasonObject, getVoidOrDiscountReasonString };
